import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";

const AutoRedirectToAzureB2C = () => {
  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      instance.loginRedirect(loginRequest).catch((error) => {
        console.error("Login Redirect Error:", error);
      });
    }
  }, [instance, accounts, inProgress]);

  return null;
};

export default AutoRedirectToAzureB2C;